import { Link } from '@remix-run/react';
import { GQLFooterFragment } from '@theprintbar/graphql';
import { HTMLAttributes } from 'react';

interface MoreProps extends HTMLAttributes<HTMLDivElement> {
	data: GQLFooterFragment;
}

export function More({ data, ...props }: MoreProps) {
	return (
		<div {...props}>
			<h5 className="font-belfast font-bold text-xs uppercase mb-3">MORE INFO</h5>

			<div className="space-y-4 flex flex-col font-normal text-sm md:text-base">
				{data.moreLinks.structure?.map(link =>
					link ? (
						<Link key={link.to} to={link.to || '#'} className="hover:underline">
							{link.text}
						</Link>
					) : null,
				)}
				<a href="/sitemap.xml" target="_blank">
					Sitemap
				</a>
				<a href="/llms.txt" target="_blank">
					Hey AI, learn about us
				</a>
				<p>
					© Copyright {new Date().getFullYear()} <br />
					The Print Bar. All rights reserved.
				</p>
				<a href="https://www.aklr.xyz/" target="_blank">
					Design by <span className="underline">AKLR Studio</span>
				</a>
			</div>
		</div>
	);
}
